import { Component, computed, input, output } from '@angular/core'

import { ColDef } from 'ag-grid-community'

import { TOKEN_STATE } from '@flowx/core-sdk'
import { PROCESS_INSTANCE_COLUMNS } from '@flowx/designer/modules/process/process.constants'
import {
  DefaultActionsColumn,
  FlxResourcesGridComponent,
} from '@flowx/designer/modules/projects/components/resources-grid/resources-grid.component'
import { ActionsCellComponent } from '@flowx/designer/shared/components/ag-grid/cell-components/actions-cell/actions-cell.component'
import { ApplicationDefinition } from '@flowx/designer/shared/entities/application.entity'
import { ProcessInstance } from '@flowx/designer/shared/entities/process-instance.types'

@Component({
  selector: 'app-process-instance-subprocesses',
  templateUrl: './process-instance-subprocesses.component.html',
  imports: [FlxResourcesGridComponent],
})
export class ProcessInstanceSubprocessesComponent {
  processInstance = input<ProcessInstance>()
  path = input<{ name: string; uuid: string }[]>()
  goToProcess = output<string>()

  items = computed(() =>
    this.processInstance()?.subProcesses?.map((subprocess) => ({
      ...subprocess,
      node: subprocess?.tokens?.find((token) => token.state === TOKEN_STATE.ACTIVE)
        ?.currentNodeName,
    }))
  )

  subprocessesTableCols: ColDef[] = [
    ...PROCESS_INSTANCE_COLUMNS,
    {
      ...DefaultActionsColumn,
      cellRenderer: ActionsCellComponent<ApplicationDefinition>,
      cellRendererParams: {
        actions: [
          {
            icon: 'ph-eye',
            tooltip: 'Navigate to subprocess',
            clickAction: (process: ProcessInstance): void => this.onGoToSubprocess(process.uuid),
          },
        ],
      },
    },
  ]

  onGoToSubprocess(subprocessUuid: string): void {
    this.goToProcess.emit(subprocessUuid)
  }
}
